<template>
  <div class="modal-card" style="width: auto; height : 100rem;">
    <header class="modal-card-head">
      <p class="modal-card-title">Manage Seasons</p>
    </header>
    <section class="modal-card-body">
      <b-field label="Season Name">
        <b-input
            type="text"
            icon="snowflake"
            v-model="label"
            placeholder="e.g. High Season"
            required>
        </b-input>
      </b-field>
      <div class="columns">
        <div class="column">
          <b-field label="Start Date">
            <b-datepicker
                v-model="startDate"
                placeholder="Click to select..."
                icon="calendar-alt"
                >
            </b-datepicker>
          </b-field>
        </div>
        <div class="column">
          <b-field label="End time">
            <b-datepicker
                v-model="endDate"
                placeholder="Click to select..."
                icon="calendar-alt"
                >
            </b-datepicker>
          </b-field>
        </div>
      </div>
   
<!--      
      <div class="columns mt-1">
        <div class="column">
          <b-switch v-model="active">Active</b-switch>        
        </div>
       
      </div> -->
    </section>
    <footer class="modal-card-foot">
      <button class="button is-primary full-width-button" :class="{'is-loading': isLoading}" @click="manageDeliveryOption">Save</button>
    </footer>
  </div>
</template>

<script>
import moment from 'moment';
import DeliveryOptionsService from './service';

export default {
  name: 'manageSeasons',

  props: ['city', 'option'],

  created() {
    if (this.option.docId) {
      let {
        docId,
        label,
        startDate,
        endDate,
       // active,
      } = this.option;

      this.docId = docId;
      this.label = label;
   
      //this.active = active;
       this.startDate = moment(this.option.startDate).toDate();
       this.endDate = moment(this.option.endtDate).toDate();
     //this.startDate = this.option.startDate;
     //this.endDate = this.option.endDate;
    }
  },

  data() {
    return {
      isLoading: false,
      docId: null,
      label: null,
      startDate: null,
      endDate: null,
    
      //active: false,
     
    };
  },

  methods: {
    manageDeliveryOption() {
      this.isLoading = true;

      DeliveryOptionsService.manage(
        this.city,
        this.docId,
        this.label,
        this.startDate,
        this.endDate,
       // this.active,
       
      ).then(() => {
        this.isLoading = false;
        this.$toast.open('Saved successfully');
        this.$emit('close');
      });
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/hotel/Seasons/ManageSeasons.vue